import { PDFViewer } from "@react-pdf/renderer";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import FormPermohonanKapal from "../../../cetak/kapal/FormPermohonanKapal";

const ModalCetakPermohonanKapal = ({ showCetak, handleCloseCetak, datappm }) => {
//   const nonLalinService = useMemo(() => new NonlalinService(), []);
  const [maksudKegiatan, setMaksudKegiatan] = useState(null);

//   const fetchAllData = useCallback(async () => {
//     if (!datappm?.nomorAju) return;

//     try {


//     //   const [resMaksud] = results;

//       const getData = (res, fallback = null) =>
//         res && res.status === "fulfilled"
//           ? res.value?.data?.data ?? res.value?.data ?? fallback
//           : fallback;

//       setMaksudKegiatan(getData(resMaksud));
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   }, [, datappm]);

//   useEffect(() => {
//     if (showCetak) {
//       fetchAllData();
//     }
//   }, [showCetak, fetchAllData]);

  return (
    <>
      <Modal
        show={showCetak}
        onHide={handleCloseCetak}
        keyboard={false}
        size="xl"
        centered
      >
        <Modal.Body>
            <PDFViewer style={{ width: 1105, height: 800 }}>
                {maksudKegiatan?.urMaksudKegiatan === "CPIB Kapal" ? (
                <FormPermohonanKapal 
                // datappm={datappm} maksudKegiatan={maksudKegiatan} 
                />
                ) : (
                
                <FormPermohonanKapal 
                // datappm={datappm} maksudKegiatan={maksudKegiatan} 
                />
                )}
            </PDFViewer>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalCetakPermohonanKapal;